import React, { useEffect } from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { useUnit } from "effector-react"

import { AppContext, AppContextProvider, ErrorPage } from "@dit/core-frontend"
import { MainContext, MainContextProvider } from "@components/contexts/MainContext"
import {
  HomePage,
  ZonesPage,
  ZonePage,
  FavoritesPage,
  RecentWorkPage,
  UserProfilePage,
} from "@pages"
import { Loader } from "@mos-cat/ds"

import { API_ENDPOINTS, modulesLinks, ROUTES } from "@constants"
import { checkPermission, $isPermissionsLoading, loadPermissions } from "../store/permissionModel"
import AllPagesPage from "@src/pages/AllPages"
import { Helmet } from "react-helmet"
import { HISTORY_WORK_TYPE } from "@pages/RecentWork/RecentWorkUtils"
import { Header } from "./Header"

const RedirectToHome = () => <Navigate to={ROUTES.HOME} replace />

export const checkPermissionOrRenderError = (permission, Component) => {
  return checkPermission(permission) ? (
    <Component />
  ) : (
    <ErrorPage
      code="403"
      title="Доступ запрещен"
      text="У вас нет прав доступа к этой странице"
      mainLink={ROUTES.HOME}
    />
  )
}

export const MainLayout = () => {
  const isLoading = useUnit($isPermissionsLoading)
  const loadpermissions = useUnit(loadPermissions)

  useEffect(() => {
    loadpermissions?.()
  }, [loadpermissions])

  if (isLoading) {
    return (
      <Loader
        bg={["gray-05", "white"]}
        space="sp-16"
        wrapper="div"
        style={{ display: "flex", alignItems: "center" }}
        overlayVisible
      />
    )
  }

  return (
    <AppContextProvider
      endpointMeUrl={API_ENDPOINTS.me}
      urlOnNotAuthorized={ROUTES.HOME}
      currentModule="wiki"
      modulesLinks={modulesLinks}
    >
      <AppContext.Consumer>
        {() => {
          return (
            <BrowserRouter>
              <Header />
              <Helmet title="МосВики" />
              <MainContextProvider>
                <MainContext.Consumer>
                  {() => (
                    <Routes>
                      <Route path="/" element={<RedirectToHome />} />
                      <Route path={ROUTES.HOME} element={<HomePage />} exact />
                      <Route
                        path={`${ROUTES.ZONES_LIST}`}
                        element={checkPermissionOrRenderError("ZONE_LIST_READ", ZonesPage)}
                      />
                      <Route
                        path={`${ROUTES.ZONE}/:zoneSlug/*`}
                        element={checkPermissionOrRenderError("PAGE_LIST_READ", ZonePage)}
                      />
                      <Route
                        path={ROUTES.RESENT_WORK}
                        element={<RecentWorkPage type={HISTORY_WORK_TYPE.EDIT} />}
                      />
                      <Route
                        path={ROUTES.VIEW_HISTORY}
                        element={<RecentWorkPage type={HISTORY_WORK_TYPE.VIEW} />}
                      />
                      <Route path={ROUTES.FAVORITES} element={<FavoritesPage />} />
                      <Route path={`${ROUTES.PAGES_LIST}`} element={<AllPagesPage />} />
                      <Route path={`${ROUTES.PROFILE}/:id`} element={<UserProfilePage />} />
                      <Route path="*" element={<ErrorPage mainLink={ROUTES.HOME} />} />
                    </Routes>
                  )}
                </MainContext.Consumer>
              </MainContextProvider>
            </BrowserRouter>
          )
        }}
      </AppContext.Consumer>
    </AppContextProvider>
  )
}
